// Centroides aproximados por país (ISO 3166-1 alpha-2), no formato [lon, lat].
// Usados para posicionar marcadores no mapa-múndi. Códigos ausentes apenas não
// renderizam marcador.
export const CENTROIDS = {
  AE: [54.0, 24.0], AF: [66.0, 33.0], AL: [20.0, 41.0], AM: [45.0, 40.0],
  AO: [17.5, -12.5], AR: [-64.0, -34.0], AT: [13.3, 47.5], AU: [134.0, -25.0],
  AZ: [47.5, 40.3], BA: [18.0, 44.0], BD: [90.0, 24.0], BE: [4.5, 50.8],
  BF: [-2.0, 12.5], BG: [25.0, 43.0], BH: [50.5, 26.0], BJ: [2.3, 9.5],
  BO: [-65.0, -17.0], BR: [-51.9, -10.8], BW: [24.0, -22.0], BY: [28.0, 53.5],
  CA: [-106.0, 56.0], CD: [23.6, -2.9], CF: [20.9, 6.6], CG: [15.0, -1.0],
  CH: [8.2, 46.8], CI: [-5.5, 7.5], CL: [-71.0, -35.0], CM: [12.0, 6.0],
  CN: [104.0, 35.0], CO: [-73.0, 4.0], CR: [-84.0, 10.0], CU: [-79.0, 22.0],
  CY: [33.0, 35.0], CZ: [15.5, 49.8], DE: [10.4, 51.1], DK: [9.5, 56.0],
  DO: [-70.7, 19.0], DZ: [2.6, 28.0], EC: [-78.0, -1.5], EE: [25.5, 58.7],
  EG: [30.0, 26.8], ES: [-3.7, 40.2], ET: [40.0, 8.0], FI: [26.0, 64.0],
  FR: [2.5, 46.5], GB: [-1.5, 52.5], GE: [43.5, 42.0], GH: [-1.0, 7.9],
  GR: [22.0, 39.0], GT: [-90.4, 15.5], HK: [114.1, 22.3], HN: [-86.5, 14.8],
  HR: [15.5, 45.1], HU: [19.5, 47.2], ID: [118.0, -2.5], IE: [-8.0, 53.4],
  IL: [35.0, 31.5], IN: [79.0, 22.0], IQ: [44.0, 33.0], IR: [53.0, 32.0],
  IS: [-18.5, 64.9], IT: [12.6, 42.8], JO: [36.2, 31.2], JP: [138.0, 36.5],
  KE: [38.0, 1.0], KH: [105.0, 12.5], KR: [127.8, 36.5], KW: [47.6, 29.3],
  KZ: [67.0, 48.0], LA: [103.0, 18.0], LB: [35.9, 33.9], LK: [81.0, 7.9],
  LT: [24.0, 55.2], LU: [6.1, 49.8], LV: [24.9, 56.9], LY: [17.0, 27.0],
  MA: [-7.0, 32.0], MD: [28.5, 47.2], MK: [21.7, 41.6], ML: [-4.0, 17.0],
  MM: [96.0, 21.0], MN: [103.0, 46.8], MX: [-102.0, 23.6], MY: [109.0, 4.2],
  MZ: [35.5, -18.7], NA: [17.0, -22.0], NG: [8.0, 9.6], NL: [5.3, 52.1],
  NO: [9.0, 61.0], NP: [84.0, 28.4], NZ: [172.0, -41.0], OM: [56.0, 21.0],
  PA: [-80.1, 8.5], PE: [-75.0, -9.2], PH: [122.0, 12.9], PK: [69.0, 30.0],
  PL: [19.4, 52.1], PT: [-8.2, 39.6], PY: [-58.4, -23.4], QA: [51.2, 25.3],
  RO: [25.0, 45.9], RS: [21.0, 44.0], RU: [90.0, 61.5], RW: [29.9, -2.0],
  SA: [45.0, 24.0], SE: [16.0, 62.0], SG: [103.8, 1.36], SI: [14.8, 46.1],
  SK: [19.5, 48.7], SN: [-14.5, 14.5], SV: [-88.9, 13.8], SY: [38.0, 35.0],
  TH: [101.0, 15.0], TN: [9.5, 34.0], TR: [35.0, 39.0], TW: [121.0, 23.8],
  TZ: [34.9, -6.4], UA: [32.0, 49.0], UG: [32.3, 1.4], US: [-98.5, 39.8],
  UY: [-56.0, -32.8], UZ: [64.0, 41.5], VE: [-66.0, 7.1], VN: [106.0, 16.0],
  YE: [48.0, 15.5], ZA: [25.0, -29.0], ZM: [27.8, -13.1], ZW: [29.8, -19.0],
};

// Emoji de bandeira a partir do código ISO2 (regional indicators).
export function flagEmoji(code) {
  if (!code || code.length !== 2) return "";
  const base = 0x1f1e6;
  return String.fromCodePoint(
    base + code.toUpperCase().charCodeAt(0) - 65,
    base + code.toUpperCase().charCodeAt(1) - 65
  );
}
